<script setup>
import { computed } from "vue"
import { createToaster } from "@meforma/vue-toaster"

const props = defineProps({
  keywordBlocks: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close'])

const toaster = createToaster({
  position: "bottom-right",
  duration: 4000,
})

const blockedKeywords = computed(() => {
  return props.keywordBlocks.filter(block => block.keyword)
})

const copyBlockedKeywords = () => {
  if (blockedKeywords.value.length === 0) return

  const text = blockedKeywords.value.map(block => block.keyword).join('\n')
  navigator.clipboard.writeText(text).then(() => {
    toaster.show("Blocked sources copied to clipboard", { type: "success" })
  })
}
</script>

<template>
  <div class="panel max-w-lg">
    <div class="panel-header flex justify-between items-center">
      <h2 class="font-semibold">Blocked Sources</h2>
      <button @click="$emit('close')" class="btn btn-ghost btn-sm btn-circle">
        <v-icon name="io-close" scale="1.2" />
      </button>
    </div>
    <div class="panel-body">
      <p class="text-sm text-base-content/60 mb-4">
        The following sources are blocked across all campaigns on your account.
        Traffic from these sources will not generate payouts.
      </p>

      <div class="flex justify-end mb-2">
        <button
          @click="copyBlockedKeywords"
          v-tooltip="'Copy all blocked sources to clipboard'"
          class="btn btn-sm btn-ghost"
        >
          <v-icon name="hi-clipboard-copy" scale="1" />
          <span class="ml-1">Copy All</span>
        </button>
      </div>

      <div class="overflow-y-auto max-h-64">
        <table class="table table-sm w-full">
          <thead>
            <tr class="text-base-content/60">
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="block in blockedKeywords" :key="block.id">
              <td class="font-mono text-error">{{ block.keyword }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
